
import Vue from "vue";

export default Vue.extend({
  name: "AppModal",
  methods: {
    close(): void {
      this.$emit("close");
    },
  },
});
